import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9fd60b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "punchoutHeader",
  class: "punchout-header"
}

import {computed, ref} from 'vue';
    import PunchoutDialog from './punchout-dialog/index.vue';
    import {useUser} from '../../user';
    import {ProfileAvailability} from '@/common/api';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderPunchout',
  setup(__props) {

    const userStore = useUser();
    const punchoutDetails = computed(() => userStore.selectedIdentity?.punchoutDetails);
    const isSessionActive = computed(() => userStore.user?.punchoutSessionActive);

    const status = ref<ProfileAvailability>(isSessionActive.value ? 'AVAILABLE_AND_VERIFIED' : 'NOT_AVAILABLE');
    const punchoutDialogOpen = ref<Boolean>(false);

    function onClick() {
        punchoutDialogOpen.value = !punchoutDialogOpen.value;
    }

    function handleDialogClosed() {
        punchoutDialogOpen.value = false;
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyAvailability = _resolveComponent("VJoyAvailability")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade-scale" }, {
      default: _withCtx(() => [
        (punchoutDialogOpen.value)
          ? (_openBlock(), _createBlock(PunchoutDialog, {
              key: 0,
              "punchout-details": punchoutDetails.value,
              "is-session-active": isSessionActive.value,
              onDialogClosed: handleDialogClosed
            }, null, 8, ["punchout-details", "is-session-active"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_VJoyAvailability, {
      class: "punchout-badge",
      "data-testid": "navbar-punchout",
      status: status.value,
      label: punchoutDetails.value?.procurementAppName,
      onClick: onClick
    }, null, 8, ["status", "label"])
  ]))
}
}

})